export const {
    REACT_APP_API_URL,
    REACT_APP_BASE_BACKEND_URL,
    RECAPTCHA_SIT_KEY
} = process.env;